import { Images } from 'assets/images';
import { StepperPage } from './StepperPage';
import {
  StyledImageContainer,
  StyledQuestionsContainer,
  StyledWrapperText,
  SuccessRequestPage,
} from './styled';

export const QuestionsContent = ({
  setAnswerItem,
  answers,
  setAnswers,
  setIsChooseAnswer,
  activeStep,
  answerItem,
  questions,
}) => {
  const generateAnswersObject = (answer) => {
    setAnswerItem(answer);
    const found = answers.some((el) => el.position === answer.position);

    if (found) {
      const answersObject = answers.map((item) =>
        item.position === answer.position ? answer : item,
      );
      setAnswers(answersObject);
      if (answer?.selectedAnswers?.length) {
        setIsChooseAnswer(true);
      }
    } else {
      setAnswers((prev) => [...prev, answer]);
    }
  };

  if (!questions.data?.length) {
    return null;
  }

  return (
    <StyledQuestionsContainer>
      {activeStep <= questions.data?.length ? (
        <StepperPage
          generateAnswersObject={generateAnswersObject}
          page={activeStep}
          answerItem={answerItem}
          questions={questions}
        />
      ) : (
        <SuccessRequestPage>
          <StyledImageContainer src={Images.success} alt="" />

          <StyledWrapperText>
            Thank you for your response! We will get back to you with the awesomely
            offers in 24 hours!
          </StyledWrapperText>
        </SuccessRequestPage>
      )}
    </StyledQuestionsContainer>
  );
};
